import { render, staticRenderFns } from "./DojoWidget.vue?vue&type=template&id=6ee9fb1d"
import script from "./DojoWidget.vue?vue&type=script&lang=js"
export * from "./DojoWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports